import PropTypes from 'prop-types';

import { IconWarningOutline, Spacer } from '@zillow/constellation';
import { Button, Text } from '@zillow/constellation-10';

import { PAYMENT_CONSTANTS } from '../../../constants/PaymentConstants';

import { StyledPaymentError } from './StyledComponents';

const propTypes = {
  errorMessage: PropTypes.string.isRequired,
  defaultErrorMessage: PropTypes.string,
  isInMaintenanceMode: PropTypes.bool,
};

const defaultProps = {
  defaultErrorMessage: PAYMENT_CONSTANTS.ERROR_TYPE.DEFAULT,
  isInMaintenanceMode: false,
};

const PaymentError = ({ errorMessage, defaultErrorMessage, isInMaintenanceMode }) => (
  <StyledPaymentError>
    <Spacer
      paddingX="md"
      paddingY="lg"
      className={`PaymentError-header ${isInMaintenanceMode ? 'maintenanceMode' : ''}`}
    >
      <IconWarningOutline fontColor="white" size="lg" />
    </Spacer>
    <Spacer padding="lg" className="PaymentError-body">
      <Text>{errorMessage || defaultErrorMessage}</Text>
    </Spacer>
    <Spacer paddingBottom="sm">
      <Button fluid tone="brand" emphasis="outlined" onClick={() => location.reload()}>
        Reload page
      </Button>
    </Spacer>
  </StyledPaymentError>
);

PaymentError.propTypes = propTypes;
PaymentError.defaultProps = defaultProps;

export default PaymentError;
